export default __webpack_public_path__ + "static/media/yoga-for-kids.fe3d25ec.png";